var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18",
    width: 14,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#262f5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m7 14.1q-1 0-1.8-0.3-0.8-0.3-1.4-1-0.5-0.6-0.9-1.5-0.3-0.8-0.3-1.8 0-1 0.4-1.9 0.3-0.8 0.9-1.4 0.6-0.7 1.4-1 0.8-0.4 1.8-0.4 0.6 0 1.3 0.2 0.6 0.2 1.1 0.6 0.5 0.3 0.9 0.8l-1 1q-0.5-0.6-1.1-0.9-0.6-0.3-1.2-0.3-0.7 0-1.2 0.3-0.6 0.2-1 0.6-0.4 0.5-0.6 1.1-0.2 0.5-0.2 1.3 0 0.7 0.2 1.3 0.2 0.6 0.6 1 0.4 0.5 1 0.7 0.6 0.2 1.3 0.2 0.4 0 0.8-0.1 0.5-0.1 0.8-0.3 0.4-0.3 0.7-0.6l0.7 1.2q-0.3 0.3-0.8 0.6-0.5 0.3-1.2 0.5-0.6 0.1-1.2 0.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2.6 0h10.9v15.4l-2.6 2.6h-10.9v-15.4zm9.8 14.9v-13.8h-9.3l-2 1.9v13.9h9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.d0b3ba6ccfed115b657d7811b4fcd552.svg";
export { ForwardRef as ReactComponent };